<!--
 * @Author: your name
 * @Date: 2021-05-20 11:07:43
 * @LastEditTime: 2021-06-03 17:42:54
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \VtpWechatUI\src\components\HelloWorld.vue
-->
<template>
  <div :model="model" style="background:#FAFAFA">
    <!-- <div class="weui-cells__title" style="font-weight:bold;font-size:110%;background-color: transparent;">入园申请</div> -->
    <!-- <div class="link-top" tyle="width: 50%;height: 1px;border-top: solid #ACC0D8 1px;"></div> -->
    <div class="weui-cells__title" align="left" style="background:#FAFAFA">被访人信息</div>
    <div class="weui-cells weui-cells_form">
      <div class="weui-cell" align="left">
        <div class="weui-cell__hd" style="width:20%">
          <label class="weui-label" prop="visitedname" style="float:left">姓名：<span style="color:red">*</span></label>
        </div>
        <div class="weui-cell__bd" style="float:right">
          <input v-model="model.visitedname" class="weui-input" type="text" required="required">
        </div>
      </div>
      <div class="weui-cell lineHeng">
      </div>
    </div>
    <div class="weui-cells weui-cells_form">
      <div class="weui-cell">
        <div class="weui-cell__hd" style="width:20%">
          <label class="weui-label" align="left" prop="visitedphonenum">电话：<span style="color:red">*</span></label>
        </div>
        <div class="weui-cell__bd">
          <input v-model="model.visitedphonenum" class="weui-input" type="number" @change="visitedphonenumChange($event)" placeholder="">
        </div>
      </div>
      <div class="weui-cell lineHeng">
      </div>
    </div>
    <div class="weui-cells weui-cells_form">
      <div class="weui-cell">
        <div class="weui-cell__hd" style="width:20%">
          <label class="weui-label" align="left" prop="visiteddeptfullname">部门：</label>
        </div>
        <div class="weui-cell__bd">
          <input v-model="model.visiteddeptfullname" class="weui-input" type="text" style="font-size:14px" disabled placeholder="正确填写手机号后自动填充">
        </div>
      </div>
      <div class="weui-cell lineHeng">
      </div>
    </div>
    <div class="weui-cells__title" align="left">访客信息</div>
    <div class="weui-cells weui-cells_form">
      <div class="weui-cell">
        <div class="weui-cell__hd" style="width:20%"><label class="weui-label" align="left">姓名：<span style="color:red">*</span></label></div>
        <div class="weui-cell__bd">
          <input v-model="model.visitorname" class="weui-input" type="text" placeholder="">
        </div>
      </div>
      <div class="weui-cell lineHeng">
      </div>
    </div>
    <div class="weui-cells weui-cells_form">
      <div class="weui-cell">
        <div class="weui-cell__hd" style="width:20%"><label class="weui-label" align="left">电话：<span style="color:red">*</span></label></div>
        <div class="weui-cell__bd">
          <input v-model="model.visitorphonenum" class="weui-input" type="number" placeholder="">
        </div>
      </div>
      <div class="weui-cell lineHeng">
      </div>
    </div>
    <div class="weui-cells weui-cells_form">
      <div class="weui-cell">
        <div class="weui-cell__hd"><label class="weui-label" align="left">身份证号：<span style="color:red">*</span></label></div>
        <div class="weui-cell__bd">
          <input v-model="model.visitoridcard" class="weui-input" type="text" placeholder="">
        </div>
      </div>
      <div class="weui-cell lineHeng">
      </div>
    </div>
    <div class="weui-cells weui-cells_form">
      <div class="weui-cell">
        <div class="weui-cell__hd"><label class="weui-label" align="left">所属单位：<span style="color:red">*</span></label></div>
        <div class="weui-cell__bd">
          <input v-model="model.visitorcompony" class="weui-input" type="text" placeholder="">
          <!-- <van-datetime-picker v-model="currentDate" type="datetime" title="选择完整时间" :min-date="minDate" :max-date="maxDate" /> -->
        </div>
      </div>
      <div class="weui-cell lineHeng">
      </div>
    </div>
    <div class="weui-cells weui-cells_form">
      <div class="weui-cell">
        <div class="weui-cell__hd"><label class="weui-label" align="left">入园时间：<span style="color:red">*</span></label></div>
        <div class="weui-cell__bd">
          <input v-model="model.estimateintoparktime" @focus="showpopup(1)" placeholder="时间格式2020-01-01 00:00" style="border:none;" type="primary" />
          <van-popup v-model="show" position="bottom">
            <van-datetime-picker type="datetime" :min-date="minDate" @confirm="saveTimeAction" @cancel="show= false" />
          </van-popup>
        </div>
      </div>
      <div class="weui-cell lineHeng">
      </div>
    </div>
    <div class="weui-cells weui-cells_form">
      <div class="weui-cell">
        <div class="weui-cell__hd"><label class="weui-label" align="left">离园时间：<span style="color:red">*</span></label></div>
        <div class="weui-cell__bd">
          <input v-model="model.estimateleavetime" @focus="showpopup(2)" placeholder="时间格式2020-01-01 00:00" style="border:none;" type="primary" />
          <van-popup v-model="show1" safe-area-inset-bottom position="bottom">
            <van-datetime-picker type="datetime" :min-date="minDate" @confirm="saveTimeEnd" @cancel="show1=false" />
          </van-popup>
        </div>
      </div>
      <div class="weui-cell lineHeng">
      </div>
    </div>
    <div class="weui-cells weui-cells_form">
      <div class="weui-cell">
        <div class="weui-cell__hd"><label class="weui-label" align="left">来访事由：<span style="color:red">*</span></label></div>
        <div class="weui-cell__bd">
          <input v-model="model.visitreason" class="weui-input" type="text" placeholder="">
        </div>
      </div>
      <div class="weui-cell lineHeng">
      </div>
    </div>
    <div class="weui-cells weui-cells_form">
      <div class="weui-cell">
        <div class="weui-cell__hd" style="width:20%"><label class="weui-label" align="left">车牌号：</label></div>
        <div class="weui-cell__bd">
          <input v-model="model.carnumber" class="weui-input" type="text" placeholder="">
        </div>
      </div>
      <div class="weui-cell lineHeng">
      </div>
    </div>
    <div class="weui-cells__title" align="left">同行者信息</div>
    <div>
      <div v-for="(list,index) in lists" :key="list.index">
        <div class="weui-cells weui-cells_form">
          <div class="weui-cell">
            <div class="weui-cell__hd" style="width:20%">
              <label class="weui-label" align="left">姓名：<span style="color:red">*</span></label>
            </div>
            <div class="weui-cell__bd">
              <input v-model="list.visitorname" class="weui-input" type="text" placeholder="" sytle="width:75%">
            </div>
            <span>
              <van-button @click="del(index)" plain type="info" style="border:none;color:#169BD5">删除同行者</van-button>
            </span>
          </div>
          <div class="weui-cell lineHeng">
          </div>
        </div>
        <div class="weui-cells weui-cells_form">
          <div class="weui-cell">
            <div class="weui-cell__hd" style="width:20%"><label class="weui-label" align="left">电话：<span style="color:red">*</span></label></div>
            <div class="weui-cell__bd">
              <input v-model="list.visitorphonenum" class="weui-input" type="number" placeholder="">
            </div>
          </div>
          <div class="weui-cell lineHeng">
          </div>
        </div>
        <div class="weui-cells weui-cells_form">
          <div class="weui-cell">
            <div class="weui-cell__hd"><label class="weui-label" align="left">身份证号：<span style="color:red">*</span></label></div>
            <div class="weui-cell__bd">
              <input v-model="list.visitoridcard" class="weui-input" type="text" placeholder="">
            </div>
          </div>
          <div class="weui-cell lineHeng">
          </div>
        </div>
      </div>
      <div class="weui-cells weui-cells_form" align="center">
        <!-- <img src="static\add.png" style="width:20px"> -->
        <div class="weui-cell" align="center" :style="{'background-color':addPartnerBackGroundColor}"><label class="weui-label" align="center" style="width:100%;color:#169BD5;border:none;" @click="addPartner">增加同行者</label></div>
      </div>
    </div>
    <div class="weui-btn-area">
      <button class="weui-btn weui-btn_primary" @click="enterpark(model)" style="background-color: #169BD5;color:#FFFFFF">提交</button>
    </div>
  </div>
</template>

<script>
import { getAction, postAction } from '../request/http'
import { Toast } from 'we-vue'
export default {
  name: 'HelloWorld',
  data() {
    return {
      show: false,
      show1: false,
      minDate: new Date(),
      model: {},
      screenWidth: document.body.clientWidth, // 屏幕宽
      datalist: [],
      lists: [],
      addPartnerBackGroundColor: 'white',
      pageInfo: {
        currentPage: 1, // 当前页面
        pageSize: 10,
        totalCount: 0, // 总数
        sord: 'desc',
        sidx: 'id'
      }
    }
  },
  computed: {

  },
  beforeCreate() {
    document.title = "入园申请"
  },
  created() {
  },
  mounted() {
    // getAction("/vtp/toaEnterParkApply/list", this.pageInfo).then((res) => {
    //   this.datalist = res.data.result.dataList
    // })
    this.createmore()
  },
  methods: {
    visitedphonenumChange() {
      getAction("/vtp/toaEnterParkApply/getUserDeptFullNameByMobile", { qry_mobile: this.model.visitedphonenum }).then((res) => {
        this.model.visiteddeptfullname = res.data.result.result[0].deptfullname
        this.$forceUpdate()
      })
    },
    createmore() {
      if (this.$route.params.itemid !== '' && this.$route.params.itemid !== undefined) {
        var data = {
          qry_id: this.$route.params.itemid
        }
        var that = this
        getAction("/vtp/toaEnterParkApply/list", data).then((res) => {
          if (res.data.success) {
            let entity = res.data.result.dataList[0]
            that.model.visitedname = entity.visitedname
            that.model.visitedphonenum = entity.visitedphonenum
            that.model.visitorname = entity.visitorname
            that.model.visitorphonenum = entity.visitorphonenum
            that.model.visitoridcard = entity.visitoridcard
            that.model.visitorcompony = entity.visitorcompony
            that.model.visitreason = entity.visitreason
            this.$forceUpdate()
          }
        })
      }
    },
    showpopup(index) {
      if (index === 1) {
        if (!this.show) {
          this.show = true
        } else {
          this.show = false
        }
      } else {
        if (!this.show1) {
          this.show1 = true
        } else {
          this.show1 = false
        }
      }
    },
    timeAction(time) {
      const date = new Date(time)
      var seperator1 = "-"
      var seperator2 = ":"
      var month = date.getMonth() + 1
      var strDate = date.getDate()
      var hour = date.getHours()
      if (hour.toString().length === 1) {
        hour = '0' + hour
      }
      var minutes = date.getMinutes()
      if (minutes.toString().length === 1) {
        minutes = '0' + minutes
      }
      if (month >= 1 && month <= 9) {
        month = "0" + month
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate
      }
      const a =
        date.getFullYear() +
        seperator1 +
        month +
        seperator1 +
        strDate +
        " " +
        hour +
        seperator2 +
        minutes
      this.model.estimateintoparktime = a
    },
    saveTimeAction(val) {
      this.show = false
      this.timeAction(Date.parse(val))
    },
    timeFormatterEnd(time) {
      const date = new Date(time)
      var seperator1 = "-"
      var seperator2 = ":"
      var month = date.getMonth() + 1
      var strDate = date.getDate()
      var hour = date.getHours()
      var minutes = date.getMinutes()
      if (hour.toString().length === 1) {
        hour = '0' + hour
      }
      if (minutes.toString().length === 1) {
        minutes = '0' + minutes
      }
      if (month >= 1 && month <= 9) {
        month = "0" + month
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate
      }
      const a =
        date.getFullYear() +
        seperator1 +
        month +
        seperator1 +
        strDate +
        " " +
        hour +
        seperator2 +
        minutes
      this.model.estimateleavetime = a
    },
    saveTimeEnd(val) {
      this.show1 = false
      this.timeFormatterEnd(Date.parse(val))// 选择时间日期 2019-01-30
    },
    addPartner() {
      let cope = {
        visitorname: "",
        visitorphonenum: "",
        visitoridcard: ""
      }
      this.lists.push(cope)
    },
    del(index) {
      this.lists.splice(index, 1)
    },
    beforeenpark() {
      // 没有同行者信息
      if (this.lists.length === 0) {
        // 校验访客信息
        if (this.model.visitedname === '' || this.model.visitedname === undefined ||
          this.model.visitedphonenum === '' || this.model.visitedphonenum === undefined ||
          this.model.visitorname === '' || this.model.visitorname === undefined ||
          this.model.visitorphonenum === '' || this.model.visitorphonenum === undefined ||
          this.model.visitoridcard === '' || this.model.visitoridcard === undefined ||
          this.model.visitorcompony === '' || this.model.visitorcompony === undefined ||
          this.model.estimateintoparktime === '' || this.model.estimateintoparktime === undefined ||
          this.model.estimateleavetime === '' || this.model.estimateleavetime === undefined ||
          this.model.visitreason === '' || this.model.visitreason === undefined) {
          Toast.fail('请完善您的申请信息')
          return false
        }
        if (this.model.visitedphonenum.length !== 10 && this.model.visitedphonenum.length !== 11) {
          Toast.fail('被访人的电话位数不对，请核对')
          return false
        }
        if (this.model.visitorphonenum.length !== 10 && this.model.visitorphonenum.length !== 11) {
          Toast.fail('访客的电话位数不对，请核对')
          return false
        }
        if (this.model.visitoridcard.trim().length !== 15 && this.model.visitoridcard.trim().length !== 18) {
          Toast.fail('访客的身份证位数不对，请核对')
          return false
        }
        if (this.model.visitoridcard.length === 15) {
          var n = Number(this.model.visitoridcard)
          if (isNaN(n)) {
            Toast.fail('访客的身份证信息包含非数字，请核对')
            return false
          }
        }
        if (this.model.visitoridcard.length === 18) {
          var jieqv = this.model.visitoridcard.slice(0, 17)
          var m = Number(jieqv)
          if (isNaN(m)) {
            Toast.fail('访客的身份证信息包含非数字，请核对')
            return false
          }
          var a = this.model.visitoridcard.slice(-1)
          if (this.model.visitoridcard.slice(-1) !== 'X' && isNaN(a)) {
            Toast.fail('访客的身份证信息包含非数字，请核对')
            return false
          }
        }
        return true
        // 有同行者信息
      } else {
        // 校验同行者信息
        for (var i = 0; i < this.lists.length; i++) {
          if (this.lists[i].visitorname === '' || this.lists[i].visitorname === undefined ||
            this.lists[i].visitorphonenum === '' || this.lists[i].visitorphonenum === undefined ||
            this.lists[i].visitoridcard === '' || this.lists[i].visitoridcard === undefined) {
            Toast.fail('请完善同行者的申请信息')
            return false
          }
          if (this.lists[i].visitorphonenum.length !== 10 && this.lists[i].visitorphonenum.length !== 11) {
            Toast.fail('同行者的电话位数不对，请核对')
            return false
          }
          if (this.lists[i].visitoridcard.trim().length !== 15 && this.lists[i].visitoridcard.trim().length !== 18) {
            Toast.fail('同行者的身份证位数不对，请核对')
            return false
          }
          if (this.lists[i].visitoridcard.length === 15) {
            var r = Number(this.lists[i].visitoridcard)
            if (isNaN(r)) {
              Toast.fail('同行者的身份证信息包含非数字，请核对')
              return false
            }
          }
          if (this.lists[i].visitoridcard.length === 18) {
            var w = this.lists[i].visitoridcard.slice(0, 17)
            var u = Number(w)
            if (isNaN(u)) {
              Toast.fail('同行者的身份证信息包含非数字，请核对')
              return false
            }
            var o = Number(this.model.visitoridcard.slice(-1))
            if (this.model.visitoridcard.slice(-1) !== 'X' && isNaN(o)) {
              Toast.fail('同行者的身份证信息包含非数字，请核对')
              return false
            }
          }
        }
        // 校验访客信息
        if (this.model.visitedname === '' || this.model.visitedname === undefined ||
          this.model.visitedphonenum === '' || this.model.visitedphonenum === undefined ||
          this.model.visitorname === '' || this.model.visitorname === undefined ||
          this.model.visitorphonenum === '' || this.model.visitorphonenum === undefined ||
          this.model.visitoridcard === '' || this.model.visitoridcard === undefined ||
          this.model.visitorcompony === '' || this.model.visitorcompony === undefined ||
          this.model.estimateintoparktime === '' || this.model.estimateintoparktime === undefined ||
          this.model.estimateleavetime === '' || this.model.estimateleavetime === undefined ||
          this.model.visitreason === '' || this.model.visitreason === undefined) {
          Toast.fail('请完善您的申请信息')
          return false
        }
        if (this.model.visitedphonenum.length !== 10 && this.model.visitedphonenum.length !== 11) {
          Toast.fail('被访人的电话位数不对，请核对')
          return false
        }
        if (this.model.visitorphonenum.length !== 10 && this.model.visitorphonenum.length !== 11) {
          Toast.fail('访客的电话位数不对，请核对')
          return false
        }
        if (this.model.visitoridcard.trim().length !== 15 && this.model.visitoridcard.trim().length !== 18) {
          Toast.fail('访客的身份证位数不对，请核对')
          return false
        }
        if (this.model.visitoridcard.length === 15) {
          var y = Number(this.model.visitoridcard)
          if (isNaN(y)) {
            Toast.fail('访客的身份证信息包含非数字，请核对')
            return false
          }
        }
        if (this.model.visitoridcard.length === 18) {
          var q = this.model.visitoridcard.slice(0, 17)
          var t = Number(q)
          if (isNaN(t)) {
            Toast.fail('访客的身份证信息包含非数字，请核对')
            return false
          }
          var p = this.model.visitoridcard.slice(-1)
          if (this.model.visitoridcard.slice(-1) !== 'X' && isNaN(p)) {
            Toast.fail('访客的身份证信息包含非数字，请核对')
            return false
          }
        }
        return true
      }
    },
    enterpark(model) {
      if (!this.beforeenpark()) {
        return
      }
      var loading = this.$weui.loading('处理中，请稍侯。')
      this.model.partner = this.lists
      let c = this.lists
      postAction("/vtp/toaEnterParkApply/enterpark", this.model).then((res) => {
        if (res.data.success) {
          Toast.success('申请成功')
        } else {
          Toast.success('申请失败')
        }
        loading.hide()
        this.$router.push({
          name: 'history',
          params: {
          }
        })
      }).catch((err) => {
        loading.hide()
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#app .weui-cells_form span >>> .van-button {
  height: 100%;
}
weui-cells .link-top {
  width: 100%;
  height: 1px;
  border-top: solid #acc0d8 1px;
}
.bannercontainner {
  padding: 15px;
}
.gonggao {
  flex: 1;
  background-color: rgb(252, 104, 72);
  border-radius: 15px;
  height: 35px;
  line-height: 35px;
}
.banner {
  background-image: url('../assets/banner.jpg');
  background-size: 100% 100%;
}
.greeBack {
  background-color: green;
}
#app .weui-loading_toast >>> .weui-mask_transparent {
  position: fixed;
  z-index: 1000;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background: #666666;
  opacity: 0.5;
}
.weui-mask_transparent {
  position: fixed;
  z-index: 1000;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
}
.gonggaocontent {
  flex: 4;
  height: 35px;
  text-align: left;
  line-height: 35px;
  text-indent: 15px;
}
.line {
  margin-top: 5px;
  background-color: rgb(246, 246, 246);
  height: 2px;
}
.linecontainer {
  padding-left: 10px;
  padding-right: 10px;
}
.enterParkApplyleftcontent {
  background-image: url('../assets/enterParkApply.jpg');
  background-size: 100% 100%;
  border-radius: 15px;
}
.allfunction {
  padding-top: 20px;
}
.enterParkApplyrightcontent1 {
  background-image: url('../assets/applyHistory.jpg');
  background-size: 100% 100%;
  margin-top: 10px;
  border-radius: 15px;
}
.enterParkApplyrightcontent2 {
  background-image: url('../assets/cancelApply.jpg');
  background-size: 100% 100%;
  margin-top: 10px;
  border-radius: 15px;
}
.enterParkApplycontainer {
  padding: 10px;
}
.enterParkApplyrightcontainer {
  padding-left: 0px;
  padding-right: 10px;
  padding-top: 0px;
}

#app div >>> .weui-cells::before {
  border: 0px;
}
#app div >>> .weui-cells::after {
  border: 0px;
}
#app div >>> .weui-cells {
  margin-top: 0px;
}
.lineHeng {
  margin-left: 5%;
  width: 90%;
  padding: 0px;
  border-top: 1px solid var(--weui-FG-3);
}
</style>



// WEBPACK FOOTER //
// src/components/Edit1.vue